import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNoFixtureHyphen = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 5,
	viewBox: "0 0 17 5",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("rect", {
		x: .5,
		y: .5,
		width: 16,
		height: 4,
		fill: "#7A7A7A"
	})
});
export default SvgNoFixtureHyphen;
